const { TRIM_VUE_WARNINGS } = process.env;

export default defineNuxtPlugin(() => {
    if (TRIM_VUE_WARNINGS !== 'true' && TRIM_VUE_WARNINGS !== 'mute') {
        return;
    }

    type ConsoleWarnWithPatchFlag = ((...args: unknown[]) => void) & { __isPatched?: boolean };

    if ((console.warn as ConsoleWarnWithPatchFlag).__isPatched) {
        return;
    }

    const originalWarn = console.warn.bind(console);

    const patchedWarn: ConsoleWarnWithPatchFlag = (...args: unknown[]) => {
        const firstArg = typeof args[0] === 'string' ? args[0] : '';

        if (firstArg.includes('[Vue warn]')) {
            if (TRIM_VUE_WARNINGS !== 'mute') {
                originalWarn('[Trimmed stack]: ', firstArg);
            }
            return;
        }

        originalWarn(...args);
    };

    patchedWarn.__isPatched = true;
    console.warn = patchedWarn;
});
